// Text21.js – zweiter Abschnitt der Startseite mit Text und Bildkarussell (Daten in carouselData).
import "./Home.css";
import "./custom.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";

import Boeschung from "./images/Raupe/Boeschungmulchen.webp";
import Forstmulcher from "./images/Raupe/Forstmulcher.webp";
import Seilwinde from "./images/Raupe/seilwinde.webp";

import CarouselSlide from "./CarouselSlide";
import { karussellIntervall } from "../../reducedMotion";

const carouselData = [
  {
    image: Boeschung,
    width: 1024,
    height: 575,
    title: "Mäharbeiten im schweren Gelände",
    description: "Ob Mähen, Mulchen von Böschungen oder Naturschutzflächen: Die Raupe arbeitet zuverlässig in jedem Gelände.",
    alt: "Funkgesteuerte Raupe Moritz FR 75 mulcht eine steile Grasböschung, der Bediener steht in sicherem Abstand",
  },
  {
    image: Forstmulcher,
    width: 1200,
    height: 675,
    title: "Landschaftspflege mit Forstmulcher",
    description: "Mit dem Forstmulcher können wir auch verbuschte Flächen bearbeiten und ideal für neue Projekte vorbereiten.",
    alt: "Raupe Moritz FR 75 mit Forstmulcher in dichtem Gehölzaufwuchs",
  },
  {
    image: Seilwinde,
    width: 1200,
    height: 675,
    title: "Rückearbeiten mit Seilwinde",
    description: "Auch im engen oder steilen Gelände. Rückearbeiten und Fällungen mit Raupe & Seilwinde.",
    alt: "Forstseilwinde mit roter Rückekette an der Raupe Moritz FR 75 im sonnigen Buchenwald",
  },
];

function Text21() {
  return (
    <div style={{ background: "var(--ff-black)" }}>
      <Container className="py-5">
        <div className="mb-4">
          <span className="ff-eyebrow">Spezialtechnik &amp; Landschaftspflege</span>
          <h2 className="ff-section-title">
            Problemlöser:<br />Moritz FR 75
          </h2>
        </div>
        <Row className="align-items-center py-3 gy-4">
          <Col xs={12} md={6} className="d-flex justify-content-center order-md-1" style={{ minHeight: "300px" }}>
            <Carousel
              className="w-100"
              interval={karussellIntervall(5000)}
              prevLabel="Vorherige Folie"
              nextLabel="Nächste Folie"
              indicatorLabels={carouselData.map((_, i) => `Folie ${i + 1}`)}
            >
              {carouselData.map((slide, index) => (
                <Carousel.Item key={index}>
                  <CarouselSlide {...slide} />
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
          <Col xs={12} md={6} className="text-white order-md-2">
            <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "rgba(238,244,234,.88)" }}>
              Der funkgesteuerte Geräteträger Moritz FR 75 der Firma Pfanzelt ergänzt unseren
              Fuhrpark dort, wo Spezialtechnik gefordert ist. Sie ist die ideale Lösung für anspruchsvolle
              Einsätze im Forst und in der Landschaftspflege.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "rgba(238,244,234,.88)", marginTop: "1rem" }}>
              Ausgestattet mit Forstseilwinde, Mulchkopf oder Mähwerk ermöglicht die Raupe ein
              breites Einsatzspektrum. Wenn es schwierig wird, fangen wir erst richtig an.
            </p>
            <div className="mt-4 d-flex gap-3 flex-wrap">
              <Link to="/kontakt" className="btn-ff-primary" onClick={() => window.scrollTo(0, 0)}>
                Kontaktieren Sie uns
              </Link>
              <Link to="/baumfaellung" className="btn-ff-outline" onClick={() => window.scrollTo(0, 0)}>
                Baumfällung &amp; Holzrücken
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Text21;
